import CryptoJS from 'crypto-js';

// The Master Key is stored in .env and shared between User and Admin
const MASTER_KEY = process.env.REACT_APP_SECURITY_MASTER_KEY || 'FINOVA_SECURE_PROTO_2026';

const SENSITIVE_KEYS = [
  'fullName', 'nicNumber', 'dob', 'mobileNumber', 'currentAddress', 
  'permanentAddress', 'whatsappNumber', 'jobTitle', 'workLocation',
  'nicFrontUrl', 'nicBackUrl', 'selfieUrl', 'statementsUrl', 'bankUrl', 'signatureUrl',
  'accountNumber', 'address', 'passcode', 'name', 'nic', 'phone'
];

/** 
 * Encrypts sensitive information at the field level before storing in Firestore. 
 */
export const encryptSensitiveData = (value) => {
  if (!value) return value;
  try {
    const textValue = typeof value === 'object' ? JSON.stringify(value) : String(value);
    // Check if already looks like encrypted (to avoid double encryption)
    if (textValue.startsWith('U2FsdGVkX1')) return value; 
    return CryptoJS.AES.encrypt(textValue, MASTER_KEY).toString();
  } catch (err) {
    console.error('Encryption Failed:', err);
    return value;
  }
};

/** 
 * Decrypts sensitive information retrieved from Firestore.
 */
export const decryptSensitiveData = (ciphertext) => {
  if (!ciphertext || typeof ciphertext !== 'string' || ciphertext.length < 15) return ciphertext;
  if (!ciphertext.startsWith('U2FsdGVkX1')) return ciphertext; // Not AES ciphertext
  
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, MASTER_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    
    if (!decrypted) return ciphertext;

    // Attempt to parse if it looks like JSON
    if (decrypted.startsWith('{') || decrypted.startsWith('[')) {
      try { return JSON.parse(decrypted); } catch { return decrypted; }
    }
    return decrypted;
  } catch (err) {
    return ciphertext;
  }
};

/**
 * Recursively encrypts any field that is deemed sensitive.
 */
export const sealSensitiveDoc = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  const newObj = Array.isArray(obj) ? [...obj] : { ...obj };
  Object.keys(newObj).forEach(key => {
    if (SENSITIVE_KEYS.includes(key)) {
      newObj[key] = encryptSensitiveData(newObj[key]);
    } else if (typeof newObj[key] === 'object' && newObj[key] !== null) {
      newObj[key] = sealSensitiveDoc(newObj[key]);
    }
  });
  return newObj;
};

/**
 * Recursively decrypts any field that was encrypted.
 */
export const unsealSensitiveDoc = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  const newObj = Array.isArray(obj) ? [...obj] : { ...obj };
  Object.keys(newObj).forEach(key => {
    if (SENSITIVE_KEYS.includes(key) || (typeof newObj[key] === 'string' && newObj[key].startsWith('U2FsdGVkX1'))) {
      newObj[key] = decryptSensitiveData(newObj[key]);
    } else if (typeof newObj[key] === 'object' && newObj[key] !== null) {
      newObj[key] = unsealSensitiveDoc(newObj[key]);
    }
  });
  return newObj;
};
